// @NOTE: assumes jQuery is included by WP
const $ = jQuery

import Swiper from 'swiper/bundle';

class general {
  constructor () {
    this.$window = $(window)
    //this.onWindowResize()
    //this.onWindowScroll(window.scrollY)
    this.$scrollToSection      = $('.scrolltosection')
    this.$playButton           = $('.js-play-button')
		this.$closeModalButton     = $('.js-close-modal')
		this.$player               = null 
		this.$body                 = $('body')
    this.$iframe               = $('body .video-modal iframe')
    this.modalIsOpen           = false
    this.openVideoModal()  
		this.closeVideoModal()

    this.$scrollToSection.click(function() {
      $('html, body').animate({
          scrollTop: $(".home-body-wrapper").offset().top - 80
      }, 1000);
    });


    //home slider
    if ($('.hero-slider-wrapper .swiper-container .swiper-slide').length > 1) {
      var homeslider = new Swiper ('.hero-slider', {
      direction: 'horizontal',
      loop: true,
      effect: 'fade',
      speed: 1000,
      slidersPerView: 1,
      updateOnWindowResize: true,
      autoplayDisableOnInteraction: false,

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },

      breakpoints: {
        768: {
          
        }
      },

      });
    }

    //about slider
    if ($('.about-slider .swiper-slide').length > 1) {
      var aboutslider = new Swiper ('.about-slider', {
      slidesPerView: 1.5,
      centeredSlides: true,
      paginationClickable: true,
      loop: true,
      spaceBetween: 0,
      slideToClickedSlide: true,

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      });
    }


    //content slider
    if ($('.content-slider .swiper-slide').length > 1) {
      var aboutslider = new Swiper ('.content-slider', {
      slidesPerView: 1,
      paginationClickable: true,
      loop: true,
      spaceBetween: 0,
      slideToClickedSlide: true,

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      });
    }

  }

  onWindowLoad () {
    $('.homepage-hero').css('opacity', '1');
  }
  
  openVideoModal () {
		this.$playButton.on('click', (event) => { 
      const videoIframe = $(event.currentTarget).attr('data-iframe');
      //const vimeoId = this.getIdFromVimeoURL(VideoUrl);
      //const iframeSrc = 'https://player.vimeo.com/video/'+vimeoId+'?color=ef2200&byline=0&portrait=0&autoplay=1&mute=1';
      //const videoIframe = '<iframe class="hero-video" width="100%" height="" src="'+iframeSrc+'" frameborder="0" allowfullscreen allow="autoplay" autoplay playsinline></iframe>'
      $('#iframe-video-holder').append(videoIframe);
			$('.video-modal').addClass('show-modal')
			this.$body.addClass('overflow-hidden')
			this.modalIsOpen = true 
		}) 
	}

  GetVimeoIDbyUrl(url) {
    var id = false;
    var request = new XMLHttpRequest();
    request.open('GET', 'https://vimeo.com/api/oembed.json?url='+url , false);
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
      var response = JSON.parse(request.responseText);
        if(response.video_id) {
          id = response.video_id;
        }
      }
    };
    request.send();
    return id;
  }

  closeVideoModal () {
		this.$closeModalButton.on('click', (event) => {  
			event.preventDefault();
			$(event.currentTarget).parents('.video-modal').removeClass('show-modal') 
			this.$body.removeClass('overflow-hidden')   
			$('#iframe-video-holder iframe').remove();
      this.stopIframeVideo()
      this.modalIsOpen = false
		})

		this.$body.on('click', (event) => {
			if (!this.modalIsOpen) {
				return
			}
			
			if (!$(event.target).closest('.modal-inner, .play-overlay').length) {
				$('body').find('.video-modal').removeClass('show-modal')  
				$('body').removeClass('overflow-hidden') 
				$('#iframe-video-holder iframe').remove();
        this.stopIframeVideo()
			}
		})
	}

  stopIframeVideo() {
    this.$iframe.each((index, element) => {
	    $(element).attr('src', $(element).attr('src'));
	    return false;
		});
  }

}

export default general


// WEBPACK FOOTER //
// ./src/js/custom/general/general.js